import client from '../../plugins/axios-plugin';

const MiniCartCounter = {

  _selectors: {
    counterContainer: '.js-mini-cart-counter'
  },

  init() {
    this.refreshCounters();
  },

  async refreshCounters() {
    let counter = await client.get('/cart')
      .then(response => {
        console.log('appeal', response.data.totalCartItems);

        return parseInt(response.data.totalCartItems);
      })
    ;

    this.setCountersValues( counter );

    if ( counter > 0 ) {
      this.show();
    } else {
      this.hide();
    }
  },

  setCountersValues( value ) {
    document.querySelectorAll(this._selectors.counterContainer).forEach(node => {
      node.querySelector('div').innerText = value;
    });
  },

  show() {
    document.querySelectorAll(this._selectors.counterContainer).forEach(node => {
      node.classList.add('show');
    });
  },

  hide() {
    document.querySelectorAll(this._selectors.counterContainer).forEach(node => {
      node.classList.remove('show');
    });
  }
};

export default MiniCartCounter;
